import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const heroVideoAtmosphereDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroVideo,
  componentType: LAYOUT_COMPONENT_TYPE.heroVideoAtmosphere,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroVideoAtmosphere,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Chef’s Table', 'Chef’s Table', 'Chef’s Table'),
    heading: loc3('Bei Nacht', 'After dark', 'Về đêm'),
    subheading: loc3(
      'Atmosphäre, Handwerk und Rhythmus in bewegten Bildern.',
      'Atmosphere, craft, and rhythm in motion.',
      'Không khí, tay nghề và nhịp điệu qua chuyển động.',
    ),
  },
  media: {
    heroVideo: 'https://cdn.coverr.co/videos/coverr-serving-fine-dining-1579/1080p.mp4',
    heroPoster:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1400&q=80',
  },
};
